import "./Partnership.css";

function Partnership() {
  return (
    <section className="collaboration-section">

      <div className="overlay"></div>

      <div className="collab-container">

        <p className="section-tag">
          Collaboration & Partnership
        </p>

        <h2 className="main-heading">
          Partner With Us
        </h2>

        <p className="description">
          We collaborate with colleges, institutions, startups,
          and businesses for internship programs, training
          initiatives, recruitment support, and technology
          solutions.
        </p>

        <div className="button-group">

          <button className="primary-btn">
            Partner With Us
          </button>

          <button className="secondary-btn">
            Schedule a Meeting
          </button>

        </div>

      </div>

    </section>
  );
}

export default Partnership;